import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(VDataTable, {
        key: _vm.key_component,
        staticClass: "table-inca",
        attrs: {
          headers: _vm.header_details,
          items: _vm.items,
          "sort-by": _vm.pagination_execution_detail.sort_by,
          "sort-desc": _vm.pagination_execution_detail.sort_desc,
          "hide-default-footer": true,
          page: _vm.pagination_execution_detail.current,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.pagination_execution_detail, "current", $event)
          },
          pagination: function ($event) {
            _vm.pagination_execution_detail.total = $event.itemsLength
          },
        },
        scopedSlots: _vm._u([
          {
            key: "item.passed",
            fn: function (ref) {
              var item = ref.item
              return [
                item.passed
                  ? _c(
                      VChip,
                      { attrs: { color: "green", outlined: "", small: "" } },
                      [_vm._v(_vm._s("Completado"))]
                    )
                  : _vm._e(),
              ]
            },
          },
          {
            key: "item.expectation",
            fn: function (ref) {
              var item = ref.item
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      item.rule_inca.expectation_name
                        ? item.rule_inca.expectation_name
                        : item.rule_inca.expectation
                    )
                  ),
                ]),
              ]
            },
          },
          {
            key: "item.dimension",
            fn: function (ref) {
              var item = ref.item
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      item.rule_inca.dimension_name
                        ? item.rule_inca.dimension_name
                        : item.rule_inca.dimension
                    )
                  ),
                ]),
              ]
            },
          },
          {
            key: "item.parameters",
            fn: function (ref) {
              var item = ref.item
              return [
                _c("DataplexParameterComponent", {
                  attrs: { parameters: item.rule_inca },
                }),
              ]
            },
          },
          {
            key: "item.threshold",
            fn: function (ref) {
              var item = ref.item
              return [
                item.passed
                  ? _c(
                      VChip,
                      {
                        attrs: {
                          color: item.passed ? "green" : "red",
                          outlined: "",
                          small: "",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            item.rule.threshold
                              ? item.rule.threshold * 100 + " %"
                              : ""
                          )
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            },
          },
          {
            key: "item.rowCount",
            fn: function (ref) {
              var item = ref.item
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      item.passedCount
                        ? Number.parseInt(item.evaluatedCount) -
                            Number.parseInt(item.passedCount)
                        : 0
                    ) +
                      " de " +
                      _vm._s(item.evaluatedCount) +
                      " " +
                      _vm._s(
                        item.passedCount
                          ? "(" +
                              (
                                ((Number.parseInt(item.evaluatedCount) -
                                  Number.parseInt(item.passedCount)) /
                                  Number.parseInt(item.evaluatedCount)) *
                                100
                              ).toFixed(2) +
                              " %)"
                          : ""
                      )
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
      _c("pagination-vue", {
        attrs: { pagination: _vm.pagination_execution_detail },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }